/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthApiService } from '@revenuewell/logic-http';
import { OidcService } from '@revenuewell/logic-oidc';
import { NavigationService } from '@revenuewell/logic-navigation';
import { VirtualVisitLinks, VirtualVisitRoom } from '../../hooks/virtual-visit/types';

export default class VirtualVisitService extends AuthApiService {
  private config: any

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService())
    this.config = config
  }

  startRoom = async (customerUserId: number, locationId: number, contactId: number): Promise<VirtualVisitRoom> => {
    const url = `${await this.config.virtualVisits.apiUrl}/v2/virtual-visits`
    const response = await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: customerUserId,
        locationId: locationId,
        patientId: contactId
      })
    })

    return response.json()
  }

  getLinks = async (roomNumber: number): Promise<VirtualVisitLinks> => {
    const url = `${await this.config.virtualVisits.apiUrl}/v2/virtual-visits/${roomNumber}/links/`
    const response = await this.authFetch(url, { method: 'GET' })
    return response.json()
  }
}
